
jQuery(document).ready(function ($) {


    $(window).on('load', function () {
        //bxslider
        $('.slider').each(function () {
            var ul = $(this);
            var count = $(this).children().length;

            if (count > 1) {
                ul.bxSlider({
                    nextText: '<i class="fa-light fa-arrow-right-to-line"></i>',
                    prevText: '<i class="fa-light fa-arrow-left-to-line"></i>',
                    pager: false,
                    auto: true,
                    pause: 4000,
                    autoHover: true
                });
            }
        });

        $('.sliderLogo').each(function () {

            if ($(window).width() < 550) {
                r_largeur = 1;
            } else if ($(window).width() >= 550 && $(window).width() < 750) {
                r_largeur = 3;
            } else {
                r_largeur = 5;
            }

            var ul = $(this);
            var count = $(this).children().length;

            if (count > 1) {
                ul.bxSlider({
                    controls: false,
                    pager: false,
                    auto: true,
                    pause: 4000,
                    autoHover: false,
                    minSlides: r_largeur,
                    maxSlides: r_largeur,
                    moveSlides: 1,
                    speed: 1500,
                    slideWidth: 3000,
                });
            }
        });

        $('.sliderCompetences').each(function () {
            var r_largeur;

            if ($(window).width() < 550) {
                r_largeur = 1;
            } else if ($(window).width() >= 550 && $(window).width() < 750) {
                r_largeur = 3;
            } else {
                r_largeur = 5;
            }

            var ul = $(this);
            var count = $(this).children().length;

            if (count > 1) {
                ul.bxSlider({
                    controls: false,
                    pager: false,
                    auto: true,
                    pause: 9000,
                    autoHover: false,
                    minSlides: r_largeur,
                    maxSlides: r_largeur,
                    moveSlides: 1,
                    speed: 1500,
                    infiniteLoop: true,
                    startSlide: 0,
                    touchEnabled: false
                });
            }
        });
        $('.carouselCitations').each(function () {
            var ul = $(this);
            var count = $(this).children().length;

            if (count > 1) {

                var carouselTemoignages = ul.bxSlider({
                    mode: 'horizontal',
                    startSlide: 0,
                    speed: 1000,
                    controls: false,
                    pager: true,
                    auto: true,
                    pause: 5000,
                });

            }
        });
    });

});
